import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import FooterTemplate from '@components/Footer/Footer';
import GdprConditionsTemplate from '@components/GdprConditions/GdprConditions';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { IS_PROD } from '../constants';

interface IGdprConditions {}

const GdprConditions: NextPage<IGdprConditions> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.page.common')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <GdprConditionsTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default GdprConditions;
